import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ImportSettingsComponent} from './import-settings.component';

const routes: Routes = [
  {
    path: 'import-settings',
    component: ImportSettingsComponent,
    data: {
      title: 'Import Types'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ImportSettingsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/import-settings/import-settings-routing.module.ts